/*
 * @Author: ryt_lijun qisui_jun@163.com
 * @Date: 2022-10-26 09:52:41
 * @LastEditors: bianbinbin
 * @LastEditTime: 2026-05-28 15:20:03
 * @FilePath: /ejx-web/src/router/module/index.map.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import home from '../../../home.map.js'
import goodsModule from './goods-module-map'
import HomePage from './homePage'
import notRead from './not-read.map'
import LeaderDuty from './leaderDuty.js'
import flightNormalAnalysis from './flight-normal-analysis-map.js'
import aircraftInfo from './aircraft-info.js'
import faultRetain from './fault-retain.js'
import riskMonthTrend from './risk-month-trend.js'
import jobEexecution from './job-execution.js'
import bannerOrBoard from './banner-or-board.js'
import yearlyReport from './yearlyReport.js'
import personalInfo from './personalInfo.js'
import terminalInquiry from './terminalInquiry.js'
import weatherQuery from './weatherQuery.js'
import delayReason from './delayReason.js'
import crewMealSelection from './crewMealSelection.js'
import specialPassengers from './specialPassengers.js'
import aboutBaggage from './aboutBaggage.js'
import annualReport from './annualReport.js'
import recentRiskWarning from './recentRiskWarning.js'
import switchVconsole from './switchVconsole.js'
import electronicTaskBook from './electronicTaskBook.js'
import eventLibrary from './eventLibrary.js'
import informationReporting from './informationReporting.js'
import aiChat from './aiChat.js'

// TODO 示例路由 开始开发后移除
const routerModule = [
  ...home,
  ...goodsModule,
  ...notRead,
  ...HomePage,
  ...flightNormalAnalysis,
  ...LeaderDuty,
  ...aircraftInfo,
  ...faultRetain,
  ...riskMonthTrend,
  ...jobEexecution,
  ...bannerOrBoard,
  ...yearlyReport,
  ...personalInfo,
  ...terminalInquiry,
  ...weatherQuery,
  ...delayReason,
  ...crewMealSelection,
  ...specialPassengers,
  ...aboutBaggage,
  ...annualReport,
  ...recentRiskWarning,
  ...switchVconsole,
  ...electronicTaskBook,
  ...eventLibrary,
  ...informationReporting,
  ...aiChat
]

export default routerModule
